/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function t(t){return t?.operations?.data.geometry}export{t as manipulatedObjectGeometry};
